


import Vue from 'vue';

export default Vue.extend({
    data: () => ({
        currentYear: new Date().getFullYear()
    })
});
